import {defineStore} from "pinia";
import {ref} from "vue";
import {useFetch} from "@vueuse/core";
import {BASE_URI} from "@/assets/const";

// import VueCookies from 'vue-cookies'



export const specialtiesStore = defineStore('specialtiesStore', () => {

    const isPending = ref(false)
    const specialties = ref()

    const getSpecialties = async (directionId, name) => {
        isPending.value = true;
        // const token = VueCookies.get('token');
        const { error, data } = await useFetch(BASE_URI + "/api/view/directions/"+directionId+"/specialities?query="+name, {
            method: 'GET',
            // headers: {
            //     'Authorization': `Bearer ${token}`,
            // },
        }).get().json();
            
        if (error.value) {
            console.log(error.value)
            isPending.value = false;
            return error.value;
        } else {
            specialties.value = data.value;
            console.log(specialties.value)
            isPending.value = false;
        }
    
    }

    return{
        isPending,
        getSpecialties,
        specialties
    }

})